module.exports = __webpack_public_path__ + "static/media/ico.note.65301781.svg";